import gql from 'graphql-tag'

// Operation names are Leat-prefixed: the unprefixed ones collide with
// ManageLightspeed's over the same underlying fields.
export const UPDATE_LEAT_PERSONAL_ACCESS_TOKEN = gql`
  mutation UpdateLeatMerchantIntegrationSettings($token: String) {
    updateMerchantIntegrationSettings(leatPersonalAccessToken: $token) {
      leatPersonalAccessTokenSet
    }
  }
`

export const FETCH_LEAT_STORES = gql`
  query FetchLeatStores {
    fetchLeatStores {
      uuid
      name
      type
    }
  }
`

export const GET_LEAT_STORE_SETTINGS = gql`
  query GetLeatStoreSettings($merchantId: uuid!) {
    stores(where: { merchant_id: { _eq: $merchantId } }) {
      id
      store_integration_settings {
        leat_store_id
        leat_order_push_enabled
      }
    }
  }
`

// Raw-Hasura. Counts every customer, not only marketing opt-ins.
export const GET_CUSTOMER_COUNT = gql`
  query GetCustomerCount($merchantId: uuid!) {
    customers_aggregate(where: { merchant_id: { _eq: $merchantId } }) {
      aggregate {
        count
      }
    }
  }
`

export const UPDATE_STORE_INTEGRATION_SETTINGS = gql`
  mutation UpdateLeatStoreIntegrationSettings(
    $partnerName: PartnerName!
    $storeId: uuid!
    $leatStoreId: String
    $leatOrderPushEnabled: Boolean
  ) {
    updateStoreIntegrationSettings(
      partnerName: $partnerName
      storeId: $storeId
      leatStoreId: $leatStoreId
      leatOrderPushEnabled: $leatOrderPushEnabled
    ) {
      id
      integrationSettings {
        leatStoreId
        leatOrderPushEnabled
      }
    }
  }
`

export const UPDATE_LOYALTY_IMPLEMENTATION = gql`
  mutation UpdateLoyaltyImplementation(
    $merchantId: uuid!
    $loyaltyImplementation: LoyaltyImplementation!
  ) {
    updateMerchant(
      merchantId: $merchantId
      params: { loyaltyImplementation: $loyaltyImplementation }
    ) {
      id
      loyaltyImplementation
    }
  }
`

export const SYNC_LEAT_CATALOGUE = gql`
  mutation SyncLeatCatalogue {
    syncLeatCatalogue {
      tokenSet
      categories {
        total
        synced
        pending
        unaccounted
        skipped
      }
      products {
        total
        synced
        pending
        unaccounted
        skipped
      }
      modifiers {
        total
        synced
        pending
        unaccounted
        skipped
      }
      customers {
        total
        synced
        pending
        unaccounted
        anonymised
        missing_email
      }
    }
  }
`
